import axios from 'axios'
import {AUTH_LOG_USER_OUT, SET_INVALID_TOKEN} from "@/store/action-types";
import auth from "@/store/modules/auth";
import store from '@/store'
import router from '@/router'
import {IS_DELETE_CONFIRMATION, IS_ORDER_CONFIRMATION} from "@/store/getter-types";

function addDefaultHeadersInterceptor (config: any): any {
  config.headers.get['Accept'] = 'application/json'

  // Without a token, no Authorization header at all: 'Bearer null' makes the
  // JWT authenticator fail public endpoints with 401 (broke smart links for
  // logged-out visitors). The anonymous endpoints of the permalink/onboarding
  // flow never get a header either — a stale token would 401 them the same
  // way, and the authenticator runs before the anonymous allowlist.
  const publicEndpoints = ['smart-link/slug/', 'customer/with-groups', 'request/anonymous']
  const isPublicEndpoint = typeof config.url === 'string'
    && publicEndpoints.some((endpoint) => config.url.includes(endpoint))
  const token = localStorage.getItem('token')

  if (token && !isPublicEndpoint && config.method && config.headers && config.headers[config.method]) {
    config.headers[config.method]['Authorization'] = 'Bearer ' + token
  }

  return config
}

const config = {
  baseURL: process.env.VUE_APP_API_ROOT
}

const instance = axios.create(config)

instance.interceptors.request.use(addDefaultHeadersInterceptor)

instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const isOrderConfirmation: boolean = store.getters[IS_ORDER_CONFIRMATION]
  const isDeleteConfirmation: boolean = store.getters[IS_DELETE_CONFIRMATION]
  if (error.response.status === 401 && !isOrderConfirmation && !isDeleteConfirmation) {
    if (auth.state.currentUser) {
      store.dispatch(SET_INVALID_TOKEN,true)
    }
    store.dispatch(AUTH_LOG_USER_OUT)
    // a 401 while already on the login page must not re-navigate —
    // vue-router raises NavigationDuplicated as an uncaught error; and the
    // public permalink page must never be yanked to login by a stale token
    if (router.currentRoute.name !== 'Login' && router.currentRoute.name !== 'Permalink') {
      router.push({ name: 'Login' }).catch(() => undefined)
    }
  }
  return Promise.reject(error)
})

export default instance
